module.exports = "/assets/b793724416d1ee09904f54c6f904c8d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/QF.png
// module id = 2872
// module chunks = 0